import React, { ChangeEvent, useEffect, useState } from 'react';
import { Button } from '../../../../../base/components/Button';
import { Icon } from '../../../../../base/components/Icon';

import { Modal } from '../../../../../base/components/Modal';
import { useAppDispatch, useAppSelector } from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { vacancyListActions } from '../../redux/slices/vacancyListSlice';

import './styles.scss';

interface Props {
    vacancyId: string;
    visible: boolean;
    closeModalHandler: () => void;
}

export const UpgradeModal = ({ vacancyId, visible, closeModalHandler }: Props) => {
    const dispatch = useAppDispatch();
    const { upgradePackages } = useAppSelector((state) => state.vacancy);
    const [selectedPackageId, setSelectedPackageId] = useState<string>('');

    useEffect(() => {
        const popularPackage = upgradePackages.find((p) => p.isPopular);
        if (popularPackage) {
            setSelectedPackageId(popularPackage.id.toString());
        }
    }, [upgradePackages]);

    const closeModal = () => closeModalHandler();

    const selectChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
        setSelectedPackageId(e.target.value);
    };

    const upgradeButtonHandler = () => {
        dispatch(vacancyListActions.upgradeVacancyRequest(vacancyId, selectedPackageId));
        closeModal();
    };

    return (
        <Modal visible={visible} visibilityHandler={closeModal} className='upgrade-vacancy-modal'>
            <div className='upgrade-vacancy-modal__content'>
                <h3 className='upgrade-vacancy-modal__title'>{__t('Премиум продвижение')}</h3>

                <ul className='upgrade-vacancy-modal__highlights'>
                    <li className='upgrade-vacancy-modal__highlight-item'>
                        <Icon icon='gift' color='danger' size='12' className='upgrade-vacancy-modal__highlight-icon' />
                        {__t('10 открытий контактов работников в подарок')}
                    </li>
                    <li className='upgrade-vacancy-modal__highlight-item'>
                        <Icon
                            icon='check'
                            color='success'
                            size='12'
                            className='upgrade-vacancy-modal__highlight-icon'
                        />
                        {__t('Приоритетное размещение вверху списка')}
                    </li>
                    <li className='upgrade-vacancy-modal__highlight-item'>
                        <Icon
                            icon='check'
                            color='success'
                            size='12'
                            className='upgrade-vacancy-modal__highlight-icon'
                        />
                        {__t('Выделение меткой')}&nbsp;🔥
                    </li>
                    <li className='upgrade-vacancy-modal__highlight-item'>
                        <Icon
                            icon='check'
                            color='success'
                            size='12'
                            className='upgrade-vacancy-modal__highlight-icon'
                        />
                        {__t('Открыты ваши контактные данные')}
                    </li>
                    <li className='upgrade-vacancy-modal__highlight-item'>
                        <Icon
                            icon='check'
                            color='success'
                            size='12'
                            className='upgrade-vacancy-modal__highlight-icon'
                        />
                        {__t('Рассылка в Viber и Telegram (100 000 подписчиков)')}
                    </li>
                </ul>

                <div className='upgrade-vacancy-modal__options'>
                    {upgradePackages.map((p) => (
                        <div className='upgrade-vacancy-option' key={p.id}>
                            <input
                                type='radio'
                                name='package'
                                value={p.id}
                                id={`vacancy-upgrade-${p.id}`}
                                className='upgrade-vacancy-option__input'
                                checked={p.id.toString() === selectedPackageId}
                                onChange={selectChangeHandler}
                            />
                            <label htmlFor={`vacancy-upgrade-${p.id}`} className='upgrade-vacancy-option__label'>
                                {p.discount && (
                                    <div className='upgrade-vacancy-option__discount-label'>
                                        {__t('Скидка')}&nbsp;
                                        {p.discount}
                                    </div>
                                )}
                                <div className='upgrade-vacancy-option__selector-icon'></div>
                                <div className='upgrade-vacancy-option__title-block'>
                                    <span className='upgrade-vacancy-option__name'>{p.name}</span>
                                    <span className='upgrade-vacancy-option__tag'>🔥&nbsp;{p.description}</span>
                                </div>
                                <div className='upgrade-vacancy-option__price-block upgrade-vacancy-option__price-block--with-discount'>
                                    <span className='upgrade-vacancy-option__price'>{p.oldPrice}</span>
                                    <span className='upgrade-vacancy-option__discount'>{p.price}</span>
                                </div>
                            </label>
                        </div>
                    ))}
                </div>

                <div className='upgrade-vacancy-modal__buttons'>
                    <Button className='upgrade-vacancy-modal__button' onClick={upgradeButtonHandler}>
                        {__t('Купить')}
                    </Button>
                    <Button className='upgrade-vacancy-modal__button' type='link' onClick={closeModal}>
                        {__t('Отмена')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
